import { useGameStore } from '../../stores/socketStore';
import { PLAYER_COLORS } from '@sheepocalypse/shared';

const MINI_KING_SHEEP = [
  '/assets/entities/sheep_blue_king.png',
  '/assets/entities/sheep_green_king.png',
  '/assets/entities/sheep_purple_king.png',
  '/assets/entities/sheep_yellow_king.png',
];

export function PlayerList() {
  const { gameState } = useGameStore();

  if (!gameState) return null;

  const players = gameState.playerOrder.map(id => gameState.players[id]);

  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4">
      <div className="mb-4 flex items-center justify-between">
        <h3 className="text-2xl font-bold text-slate-800">Lobby</h3>
        <p className="text-base text-slate-600">Turn {gameState.turn}</p>
      </div>

      <div className="space-y-2">
        {players.map(player => (
          <div
            key={player.id}
            data-testid={`game-player-${player.id}`}
            className={`flex items-center space-x-3 rounded-lg p-3 ${
              player.id === gameState.currentPlayerId
                ? 'border-2 border-blue-200 bg-blue-50'
                : 'bg-slate-100'
            }`}
          >
            <img
              className="h-8 w-8 object-contain"
              src={getMiniKingSheepAsset(player.color)}
              alt="Player marker"
            />
            <div className="flex-1">
              <p className="text-lg font-semibold text-slate-800">
                {player.name}
                {player.isAI && (
                  <span className="ml-2 rounded bg-slate-200 px-2 py-0.5 text-xs text-slate-600">
                    AI
                  </span>
                )}
              </p>
              <p className="text-sm text-slate-500">
                <span data-testid={`game-player-entities-${player.id}`}>
                  {player.entities.length}
                </span>{' '}
                entities
              </p>
            </div>
            {player.id === gameState.currentPlayerId && (
              <span
                data-testid={`game-player-turn-${player.id}`}
                className="rounded bg-blue-500 px-2 py-1 text-xs text-white"
              >
                Turn
              </span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

function getMiniKingSheepAsset(color: string | undefined): string {
  if (color) {
    const idx = PLAYER_COLORS.indexOf(color);
    if (idx >= 0) {
      return MINI_KING_SHEEP[idx % MINI_KING_SHEEP.length];
    }
  }

  return MINI_KING_SHEEP[0];
}
